import React from "react";
import { translationMessages, DEFAULT_LOCALE } from "i18n";
import * as requests from "./requests";
import { FormattedMessage } from "react-intl";
import { ROUTER_BASENAME } from "common";
import { NavLinkProps } from "types";
import { Menu } from "semantic-ui-react";
import messages from "./messages";

function loadIntlMessages() {
  let locale = DEFAULT_LOCALE;

  if (typeof window !== "undefined") {
    // if available use browser preferred language
    locale = window.navigator.language.toLowerCase();
  }

  let translatedMessages: Record<string, string>;
  // if we have translations for that locale use those otherwise default locale message
  if (locale in translationMessages) {
    translatedMessages = translationMessages[locale] || {};
  } else {
    translatedMessages = translationMessages[DEFAULT_LOCALE] || {};
  }
  return { locale, messages: translatedMessages };
}

const links: NavLinkProps[] = [
  {
    to: "/tradingLimit",
    children: (
      <Menu.Item>
        <FormattedMessage {...messages.tradingLimit} />
      </Menu.Item>
    ),
  },
  {
    to: "/restrictedConfiguration",
    children: (
      <Menu.Item>
        <FormattedMessage {...messages.restrictedConfiguration} />
      </Menu.Item>
    ),
  },
  {
    to: "/configurationSymbols",
    children: (
      <Menu.Item>
        <FormattedMessage {...messages.configurationSymbols} />
      </Menu.Item>
    ),
  },
];

const getActiveLink = (indices: number[], link: NavLinkProps, i: number) => {
  // Spread to avoid mutating param.
  const idxs = [...indices];
  const location =
    typeof window !== "undefined" ? window.location.pathname : "/";
  const isTradingLimitPage =
    (location === ROUTER_BASENAME || location === "/") &&
    link.to === "/tradingLimit";
  if (location === `/${ROUTER_BASENAME}${link.to}` || isTradingLimitPage) {
    idxs.push(i);
  }
  return idxs;
};

const isActiveLink = (index: number) =>
  index === links.reduce(getActiveLink, []).shift();

//Get a setting (by key) from window.APP_CONFIG (from config.js).
//If the setting does not exist, return an optional defaultValue or undefined.
function getAppConfigSetting(key: string, defaultValue?: string){
    // @ts-ignore
    const config = window.appConfig;
    let value;
    if (key in config) {
        //config keys are allowed to have mustache template values referencing APP_CONFIG
        value = config[key];
    }
    return (value === undefined) ? defaultValue : value;
}

export { loadIntlMessages, requests, links, getActiveLink, isActiveLink, getAppConfigSetting };
